import { Injectable } from "@angular/core";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { DatePipe } from "@angular/common";
import { map } from "rxjs/operators";
import { Observable, of, throwError } from "rxjs";
import { AlertServiceService } from "./alert-service.service";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  TxnList: any;
  allTransSum: any;
  allCountSum: any;
  dataList: any;
  roleDataList: any;
  userDataList: any;
  listCount: any = 0;
  editableData: any = {};
  mappedList: any = [];
  brandMappedList: any;
  categoryMappedList: any;
  loadingList = false;
  recentQuery = {
    term: "",
    query: {},
  };
  totals = {
    total_balance: 0,
    total_payout_balance: 0,
    total_lien: 0,
  };
  originalData: any;
  constructor(
    private http: HttpClient,
    private as: AlertServiceService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  create(term: any, data: any, shifting: any) {
    return this.http
      .post(`${environment.url}/${term}`, data, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe({
        next: (resp: any) => {
          if (resp.type === HttpEventType.UploadProgress) {
            console.log(Math.round((resp.loaded * 100) / resp.total) + "%");
          } else if (resp.type === HttpEventType.Response) {
            if (resp.body) {
              if (resp.body.success) {
                alert("Operation Successfully Done");
                this.router.navigate([`${shifting}`]);
              } else {
                alert(resp.body.message);
              }
            } else {
              alert("Operation went wrong");
            }
          }
        },
        error: (err) => {
          alert(err.error.message);
        },
      });
  }

  list(term: any, query: any) {
    this.loadingList = true;
    this.dataList = [];
    this.recentQuery = {
      term,
      query,
    };
    return this.http
      .get(`${environment.url}/${term}/`, {
        params: query,
      })
      .subscribe({
        next: (resp: any) => {
          this.setLoading(false);
          if (resp.success) {
            this.dataList = resp.data;
            this.listCount = resp?.meta?.total || this.dataList.length;
            this.totals = resp?.totals || {
              total_balance: 0,
              total_payout_balance: 0,
              total_lien: 0,
            };
            this.mappedList = resp.data.map((obj: any) => {
              return {
                value: obj._id,
                name: obj.name ? obj.name : obj.title,
              };
            });
          } else {
            this.listCount = 0;
            this.dataList = [];
            this.as.errorToast(
              resp.message ? resp.message : "Operation went wrong"
            );
          }
        },
        error: (err) => {
          this.listCount = 0;
          this.dataList = [];
          alert(err.error.message);
          this.setLoading(false);
        },
      });
  }

  roleList(term: any, query: any) {
    this.loadingList = true;
    this.roleDataList = [];
    this.recentQuery = {
      term,
      query,
    };
    return this.http
      .get(`${environment.url}/${term}/`, {
        params: query,
      })
      .subscribe({
        next: (resp: any) => {
          this.setLoading(false);
          if (resp.success) {
            this.roleDataList = resp.data
              .filter(
                (obj: any) =>
                  obj.name !== "Super Admin" && obj.name !== "Partner"
              )
              .map((obj: any) => ({
                _id: obj._id,
                name: obj.name,
              }));
          } else {
            this.listCount = 0;
            this.roleDataList = [];
            this.as.errorToast(
              resp.message ? resp.message : "Operation went wrong"
            );
          }
        },
        error: (err) => {
          this.roleDataList = [];
          alert(err.error.message);
          this.setLoading(false);
        },
      });
  }
  userListByRoleId(term: any, query: any) {
    this.loadingList = true;
    this.userDataList = [];
    this.recentQuery = {
      term,
      query,
    };
    return this.http
      .get(`${environment.url}/${term}/`, {
        params: query,
      })
      .subscribe({
        next: (resp: any) => {
          this.setLoading(false);
          if (resp.success) {
            this.userDataList = resp.data;
          } else {
            this.userDataList = [];
            this.as.errorToast(
              resp.message ? resp.message : "Operation went wrong"
            );
          }
        },
        error: (err) => {
          this.userDataList = [];
          alert(err.error.message);
          this.setLoading(false);
        },
      });
  }
  searchByFields(term: any, data: any) {
    this.loadingList = true;
    this.dataList = [];
    return this.http.post(`${environment.url}/${term}/`, data, {}).subscribe({
      next: (resp: any) => {
        this.setLoading(false);
        if (resp.success) {
          this.dataList = resp.data;
          this.listCount = 1;
          this.mappedList = resp.data.map((obj: any) => {
            return {
              value: obj._id,
              name: obj.name ? obj.name : obj.title,
            };
          });
        } else {
          this.as.errorToast(
            resp.message ? resp.message : "Operation went wrong"
          );
        }
      },
      error: (err) => {
        alert(err.error.message);
        this.setLoading(false);
      },
    });
  }
  edit(term: any, query: any, shifting: any = "") {
    if (!confirm("Are you sure?")) {
      return;
    }
    delete query.status_updated_record;
    delete query.updated_record;

    return this.http.put(`${environment.url}/${term}/`, query).subscribe({
      next: (resp: any) => {
        if (resp) {
          if (!resp.success) {
            return alert("Something Went Wrong !!");
          }
          alert("Operation Successfully Done");
          if (this.dataList && this.dataList.length) {
            this.dataList = this.dataList.map((o: any) => {
              if (o._id === query._id) {
                o = {
                  ...o,
                  ...query,
                };
              }
              return o;
            });
          }
          if (shifting) {
            this.router.navigate([`${shifting}`]);
          }
        } else {
          alert("Operation went wrong");
          this.editableData = this.originalData;
        }
      },
      error: (err) => {
        alert(err.error.message);
      },
    });
  }
  delete(term: any, id: any) {
    if (confirm("Do you really want to delete this data?")) {
      return this.http.delete(`${environment.url}/${term}/${id}`).subscribe({
        next: (resp: any) => {
          if (resp.success) {
            alert("Operation Successfully Done");
            this.dataList = this.dataList.filter((o: any) => o._id !== id);
            this.mappedList = this.mappedList.filter((o: any) => o.id !== id);
          } else {
            this.as.errorToast(
              resp.message ? resp.message : "Operation went wrong"
            );
          }
        },
        error: (err) => {
          alert(err.error.message);
        },
      });
    } else {
      return alert("Operation went wrong");
    }
  }
  restore(term: any, id: any) {
    if (confirm("Do you really want to restore this data?")) {
      return this.http
        .put(`${environment.url}/${term}/${id}/restore`, {})
        .subscribe({
          next: (resp: any) => {
            if (resp.success) {
              alert("Operation Successfully Done");
              this.dataList = this.dataList.filter((o: any) => o._id !== id);
              this.mappedList = this.mappedList.filter((o: any) => o.id !== id);
            } else {
              this.as.errorToast(
                resp.message ? resp.message : "Operation went wrong"
              );
            }
          },
          error: (err) => {
            alert(err.error.message);
          },
        });
    } else {
      return alert("Operation went wrong");
    }
  }
  getOne(term: any, query: any) {
    return this.http
      .get(`${environment.url}/${term}`, {
        params: query,
      })
      .subscribe({
        next: (resp: any) => {
          if (resp.success) {
            resp.data.dob = this.datePipe.transform(
              resp.data.dob,
              "yyyy-MM-dd"
            );
            this.editableData = resp.data;
          } else {
            this.as.errorToast(
              resp.message ? resp.message : "Operation went wrong"
            );
          }
        },
        error: (err) => {
          alert(err.error.message);
        },
      });
  }
  getOneData(url: string, params: any) {
    return this.http.get(environment.url + url, { params });
  }
  getImage(image: String | undefined | null) {
    return `${environment.url}/file/download/${image || "no-image.png"}`;
  }
  goBack() {
    return history.back();
  }
  setLoading(status: Boolean) {
    if (status) {
      this.loadingList = true;
    } else {
      setTimeout(() => {
        this.loadingList = false;
      }, 500);
    }
  }
  getUserEmail(term: string = ""): Observable<any> {
    return this.http
      .get<any>(`${environment.url}/users/getList/?email=` + term)
      .pipe(
        map((resp) => {
          if (resp) {
            return resp.data;
          } else {
            throwError(resp.error.message);
          }
        })
      );
  }
  getUserQuintusId(term: string = ""): Observable<any> {
    return this.http
      .get<any>(`${environment.url}/users/getList/?quintus_id=` + term)
      .pipe(
        map((resp) => {
          if (resp) {
            return resp.data;
          } else {
            throwError(resp.error.message);
          }
        })
      );
  }

  moveSubServicesToEnd(data: any[] = []): any[] {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    const subServicesToMove = ["YB Collect", "Payout Wallet", "Wallet"];
    const remainingItems: any[] = [];
    const endItemsOrdered: any[] = [];

    // Go through all records and split based on TransactionType + Sub_Service_Name
    data.forEach((item) => {
      if (
        item.TransactionType === "credit" &&
        subServicesToMove.includes(item.Sub_Service_Name)
      ) {
        // Temporarily skip these, collect them in order later
        return;
      } else {
        remainingItems.push(item);
      }
    });

    // Append items to end in the order defined
    subServicesToMove.forEach((subService) => {
      endItemsOrdered.push(
        ...data.filter(
          (item) =>
            item.TransactionType === "credit" &&
            item.Sub_Service_Name === subService
        )
      );
    });

    return [...remainingItems, ...endItemsOrdered];
  }
  searchList(term: any, data: any) {
    this.loadingList = true;
    this.dataList = [];
    return this.http.post(`${environment.url}/${term}/`, data, {}).subscribe({
      next: (resp: any) => {
        this.setLoading(false);
        if (resp.success) {
          this.dataList = resp.data;
          this.listCount = 1;
          this.totals = resp?.totals || {
            total_balance: 0,
            total_payout_balance: 0,
            total_lien: 0,
          };
          this.mappedList = resp.data.map((obj: any) => {
            return {
              value: obj._id,
              name: obj.name ? obj.name : obj.title,
            };
          });
          if (
            resp.data.length &&
            term === "users/transaction/getServiceSummeryForSuperAdmin"
          ) {
            this.dataList = this.moveSubServicesToEnd(resp.data);
          }
        } else {
          this.as.errorToast(
            resp.message ? resp.message : "Operation went wrong"
          );
        }
      },
      error: (err) => {
        alert(err.error.message);
        this.setLoading(false);
      },
    });
  }

  newGetServiceWiseSummary(term: any, data: any): Observable<any> {
    return this.http.post(`${environment.url}/${term}/`, data, {});
  }
  getServiceWiseSummary(term: any, data: any) {
    this.loadingList = true;
    this.dataList = [];
    return this.http.post(`${environment.url}/${term}/`, data, {}).subscribe({
      next: (resp: any) => {
        this.setLoading(false);
        this.dataList = resp.data;
        this.listCount = 1;
        if (resp.success) {
          if (
            resp.data.length &&
            term === "users/transaction/getServiceSummeryForSuperAdmin"
          ) {
            this.dataList = this.moveSubServicesToEnd(resp.data);
          }
        } else {
          this.as.errorToast(
            resp.message ? resp.message : "Operation went wrong"
          );
        }
      },
      error: (err) => {
        alert(err.error.message);
        this.setLoading(false);
      },
    });
  }
  exportSummary(data: any) {
    return this.http.post(
      `${environment.url}/users/transaction/exportServiceSummeryForSuperAdmin`,
      data,
      {
        observe: "response",
        responseType: "arraybuffer",
      }
    );
  }

  // user info to get

  getData(term: any): Observable<any> {
    return this.http.get(`${environment?.url}/users/u1/${term}`);
  }
  postData(term: any, payload: any): Observable<any> {
    return this.http.post(`${environment?.url}/users/u1/${term}`, payload);
  }
  putData(term: any, payload: any): Observable<any> {
    return this.http.put(`${environment?.url}/users/u1/${term}`, payload);
  }
  customlist(term: any, query: any) {
    this.dataList = [];
    this.listCount = 0;
    return this.http.get(`${environment.url}/users/u1/${term}/`, {
      params: query,
    });
  }
  export(term: any, payload: any): Observable<any> {
    return this.http.post(`${environment.url}/users/u1/${term}`, payload, {
      responseType: "blob",
      observe: "response", // 🔴 REQUIRED for headers
    });
  }
  newSearchList(term: any, data: any): Observable<any> {
    return this.http.post(`${environment.url}/users/u1/${term}/`, data, {});
  }

  getServiceList(term: string = ""): Observable<any> {
    return this.http.get<any>(`${environment.url}/users/u1/` + term).pipe(
      map((resp) => {
        if (resp) {
          return resp.data.map((obj: any) => {
            return {
              id: obj._id,
              name: obj.name,
              text: ` ${obj.name} -  ( ${obj.sub_service_name} )`,
              sub_service_name: obj.sub_service_name,
            };
          });
        } else {
          throwError(resp.error.message);
        }
      })
    );
  }
}
